var _defs, _text, _text2, _text3, _text4, _text5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 98.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #231f20;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-5 {\n        font-family: ArialMT, Arial;\n      }\n\n      .cls-1, .cls-5 {\n        font-size: 52.81px;\n      }\n\n      .cls-2 {\n        font-size: 64.26px;\n      }\n\n      .cls-3 {\n        font-family: Arial-BoldMT, Arial;\n        font-size: 68.65px;\n        font-weight: 700;\n      }\n\n      .cls-4 {\n        font-size: 64.25px;\n      }\n\n      .cls-5 {\n        fill: #496bb3;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(22.16 55.14) scale(.82 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(46.62 74.37) rotate(-91.42) scale(1.22 1) skewX(.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(66.03 40.65) rotate(177.89) scale(.82 1) skewX(-.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(39.72 21.08) rotate(88.58) scale(1.22 1) skewX(.56)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(93.12 72.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "duSyndic"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.c53bc8b2fefe1331c1faddf50e6dc717.svg";
export { ForwardRef as ReactComponent };